export const QA_NAME_INTEGRATIONS_PREVIEW_MODAL =
  'rentalPortalIntegrationsPreviewModal'
